import type {
  RelatedPublicSegment,
  RelatedPublicSegmentV4,
  RelatedPublicTrip,
  RelatedPublicTripV4
} from "@busbud/core-types/dist/lib/poll-service/api/udm";
import type { TripLeg } from "@busbud/int-schemas/udm";

import type {
  NapiV2CartSegment,
  NapiV2CartTrip,
  NapiV2TripItem
} from "@app/types/napi-v2-cart-types";

import { getReturnLegIfExist, isOutboundLeg } from "./get-searched-leg";

const getLegSegment = (
  segments: NapiV2CartSegment[],
  leg?: Omit<TripLeg, "segment_xids">
) => {
  return leg?.segment_ids
    ?.map(segment_id => segments?.find(s => s.id === segment_id))
    .filter(Boolean)[0];
};

export const getTripSegmentByLegNumber = (trip: NapiV2TripItem, leg: number) =>
  trip.segments.find(
    // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    segment => segment.id === trip.trip_legs[leg].segment_ids?.[0]
  );
export function getSegments(trip_item: NapiV2CartTrip) {
  const outbound_leg = trip_item?.trip_legs?.find(trip_leg =>
    isOutboundLeg(trip_leg.leg)
  );

  const return_leg = getReturnLegIfExist(trip_item);

  const outboundSegment = getLegSegment(
    trip_item.segments,
    outbound_leg
  ) as NapiV2CartSegment;
  const returnSegment = getLegSegment(trip_item.segments, return_leg);

  return { segments: trip_item.segments, outboundSegment, returnSegment };
}

export const getTripSegments = (
  trip: RelatedPublicTrip | RelatedPublicTripV4,
  segments:
    | Record<string, RelatedPublicSegment>
    | Record<string, RelatedPublicSegmentV4>
) => {
  return trip.segment_ids.map(segment_id => segments[segment_id]);
};
